import React from "react";
import PropTypes from "prop-types";
import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import { getQueuedJobs } from "../../../services/api/queuedJobs";
import { defaultSuccess } from "../../../libs/utils";
import ListView from "../../../base/ListView";
import { toImmutable } from "../../../libs/immutable-transformer";

class Queue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
      jobsMeta: {},
      jobsFilters: toImmutable({})
    };

    this._getJobs = this._getJobs.bind(this);
  }

  static propTypes = {
    prop: PropTypes.string
  };

  UNSAFE_componentWillMount() {
    getQueuedJobs().then(response => {
      this.setState({
        jobs: response.data,
        jobsMeta: response.meta
      });
    });
  }

  _handleFilterUpdate(filter) {
    this._getJobs(filter);
  }

  _getJobs(filters = this.state.jobsFilters, notify = false) {
    getQueuedJobs(filters).then(response => {
      this.setState({
        jobs: response.data,
        jobsMeta: response.meta,
        jobsFilters: filters
      });

      if (notify) {
        defaultSuccess("Reloaded");
      }
    });
  }

  render() {
    const { jobs, jobsMeta, jobsFilters } = this.state;

    const listViewConf = {
      dataSet: jobs,
      dataMeta: jobsMeta,
      columns: [
        {
          key: "id",
          value: "id"
        },
        {
          key: "status",
          value: "status"
        },
        {
          key: "queuedAt",
          value: "queuedAt"
        },
        {
          key: "completedAt",
          value: "completedAt"
        },
        {
          key: "failedAt",
          value: "failedAt"
        },
        {
          key: "timedoutAt",
          value: "timedoutAt"
        },
        {
          key: "attempts",
          value: "attempts"
        }
      ],
      baseFilters: jobsFilters,
      filters: [],
      actions: {
        deleteLink: false,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url: "/admin/queue"
    };

    return (
      <div>
        <AdminSubHeader title="Queue">
          <button
            onClick={() => this._getJobs(undefined, true)}
            className="btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air"
          >
            <i className="la la-refresh" />
          </button>
        </AdminSubHeader>
        <div className="m-content" key="content">
          <ListView
            config={listViewConf}
            handleFilterUpdate={this._handleFilterUpdate}
          />
        </div>
      </div>
    );
  }
}

export default Queue;
